
   <div id="page-container" class="main-content-boxed">
      <!-- Main Container -->
      <main id="main-container">
          <!-- Page Content -->
          <div class="bg-gd-duskx">
              <div class="hero-static content content-full bg-white invisibles" data-toggle="appears">
                  <!-- Header -->
                  <div class="py-30 px-5 text-center">

                      <h1 class="h2 font-w700 mt-50 mb-10">Registration Pending</h1>
                  </div>
                  <!-- END Header -->

                  <div>
                  <!-- Registration Confirmation -->

                  <div class="row justify-content-center px-5">
                      <div class="col-sm-8 col-md-6 col-xl-4">
                          Your registration request has been submitted. You will receive an email notifying you when your account has been approved by an administrator.
                      </div>
                  </div>
                  <!-- END Registration Confirmation -->
                  </div>


              </div>
          </div>
          <!-- END Page Content -->
      </main>
      <!-- END Main Container -->
  </div>
  <!-- END Page Container -->



